// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"footer_wrapper__DqVCd","main":"footer_main__v_t7N"};